import {ref} from "vue";
import {auth} from "@/firebase/config";

let user = ref(auth.currentUser); //no => null, yes => user information
auth.onAuthStateChanged((_user)=>{
    console.log("User State Change.Current User Is ",_user);
    user.value = _user;
});

let getUser = ()=>{
    return {user};
}
export default getUser;